<template>
    <div>

    </div>
</template>

<script setup >
import { onMounted } from 'vue';

onMounted(()=>{
    //模拟用户打开 url 中 scheme 后面参数的链接 （模拟a标签的点击）
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const scheme = params.get("scheme");
    console.log(scheme);
    const a = document.createElement("a");
    a.href = scheme;
    a.click();
})
</script>

<style lang='scss' scoped>

</style>